document.addEventListener("DOMContentLoaded", function() { 
    document.querySelector(".navbar-toggler").addEventListener('click', function(e){
        var target = document.querySelector(".navbar");
        if (target.classList.contains("open")) {
            target.classList.remove("open");
        } else {
            target.classList.add("open");
        }
    });
})



function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
  
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  
    return null; // Return null if the cookie is not found
}
  
// Update the 'href' attribute of the 'shopping-cart' element
document.addEventListener('DOMContentLoaded', function () {
    var shoppingCartLink = document.getElementById('shopping-cart');
    if (shoppingCartLink && getCookie('currentURL')) {
      shoppingCartLink.href = getCookie('currentURL');
    }
});


